export default "__VITE_ASSET__D9Xxnlz9__"